/**
 * VoicesTicker — editorial bohème-chic alternative to "Vu dans la presse".
 * Anonymous whisper-quotes that float across the screen, cp-serif italic XXL.
 * Much more chic than fake press logos — this signals INSIDER, not advertising.
 */
const VOICES = [
    { q: "Près de cinq cents villas polychromes à Mers — 1865 à 1905.", a: "Site Patrimonial Remarquable" },
    { q: "La Vallée de la Bresle souffle 75% des flacons de parfumerie du monde.", a: "Musée du Verre de Blangy" },
    { q: "Louis-Philippe reçut la reine Victoria au Château d'Eu en 1843.", a: "Entente cordiale, Musée Louis-Philippe" },
    { q: "9 300 hectares de hêtres cathédrale en forêt d'Eu.", a: "ONF" },
    { q: "2,5 km de planches, 524 cabines peintes à Cayeux.", a: "Ville de Cayeux-sur-Mer" },
    { q: "Le Neufchâtel AOP — premier fromage AOP de Normandie, mentionné dès 1035.", a: "Musée Mathon-Durand" },
    { q: "Le funiculaire du Tréport grimpe 66 mètres dans la craie — seul du genre en France.", a: "Ville du Tréport" },
];

export default function VoicesTicker() {
    const track = [...VOICES, ...VOICES]; // duplicate for seamless loop
    return (
        <section
            className="relative py-14 md:py-20 bg-cp-encre text-cp-ivoire overflow-hidden cp-grain border-y border-cp-ivoire/10"
            data-testid="voices-ticker"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 mb-10 md:mb-12 flex items-center justify-between gap-6">
                <div className="flex items-center gap-4">
                    <span className="w-10 h-px bg-cp-sable" />
                    <span className="cp-tiny text-cp-sable">Chiffres & faits documentés</span>
                </div>
                <span className="cp-tiny text-cp-ivoire/40 hidden md:inline">Sources officielles du territoire · avril 2026</span>
            </div>

            <div className="cp-marquee">
                <div className="cp-marquee__track">
                    {track.map((v, i) => (
                        <span key={i} className="inline-flex items-baseline gap-5 md:gap-8 pr-8 md:pr-14 whitespace-nowrap">
                            <span className="cp-serif italic text-3xl md:text-5xl lg:text-6xl leading-none text-cp-ivoire">
                                « {v.q} »
                            </span>
                            <span className="cp-tiny text-cp-sable">— {v.a}</span>
                            <span className="cp-serif text-4xl md:text-6xl text-cp-sable/40 leading-none">·</span>
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
